import { useRef, useState } from "react";
import { useLoader } from "../context/LoaderContext";
import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicSuccess, failed } from "../hooks/useToast";
import Select from "react-select";
import { customStyles } from "../css/select";

const ApplyForAdmission = (props) => {
  const { setLoading } = useLoader();
  const certificateInputRef = useRef(null);
  const academicInputRef = useRef(null);
  const { municipalityOption } = props;
  const [studentName, setStudentName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [gender, setGender] = useState();
  const [birthDate, setBirthDate] = useState();
  const [studentClass, setStudentClass] = useState();
  const [schoolTour, setSchoolTour] = useState();
  const [previousSchool, setPreviousSchool] = useState();
  const [previousSchoolAddress, setPreviousSchoolAddress] = useState();
  const [municipality, setMunicipality] = useState();
  const [address, setAddress] = useState();
  const [fatherName, setFatherName] = useState();
  const [motherName, setMotherName] = useState();
  const [parentName, setParentName] = useState();

  const [previewCertificate, setPreviewCertificate] = useState(null);
  const [selectedCertificate, setSelectedCertificate] = useState();
  const [isCertificatePdf, setIsCertificatePdf] = useState(false);

  const [previewAcademic, setPreviewAcademic] = useState(null);
  const [selectedAcademic, setSelectedAcademic] = useState();
  const [isAcademicPdf, setIsAcademicPdf] = useState(false);

  const schoolClass = [
    { value: "Nursery", label: "Nursery" },
    { value: "LKG", label: "LKG" },
    { value: "UKG", label: "UKG" },
    { value: "1 Class", label: "1 Class" },
    { value: "2 Class", label: "2 Class" },
    { value: "3 Class", label: "3 Class" },
    { value: "4 Class", label: "4 Class" },
    { value: "5 Class", label: "5 Class" },
  ];

  const groupedOptions = Object.entries(
    municipalityOption.reduce((acc, item) => {
      const letter = item.name.charAt(0).toUpperCase();
      if (!acc[letter]) acc[letter] = [];
      acc[letter].push({
        value: `${item.name}, ${item.district?.name || ""}`,
        label: `${item.name}, ${item.district?.name || ""}`,
      });
      return acc;
    }, {}),
  )
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([letter, items]) => ({
      label: letter,
      options: items.sort((a, b) => a.label.localeCompare(b.label)),
    }));

  const handleEditCertificate = () => {
    certificateInputRef.current?.click();
  };

  const handleCertificateChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setSelectedCertificate(file);
      setPreviewCertificate(url);
      setIsCertificatePdf(file.type === "application/pdf");
    }
  };

  const handleEditAcademic = () => {
    academicInputRef.current?.click();
  };

  const handleAcademicChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setSelectedAcademic(file);
      setPreviewAcademic(url);
      setIsAcademicPdf(file.type === "application/pdf");
    }
  };

  const [errors, setErrors] = useState({});

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const validateStep = () => {
    let newErrors = {};
    let firstErrorField = null;
    if (!email) {
      newErrors.email = "Email is required";
      if (!firstErrorField) firstErrorField = "email";
    } else if (!isValidEmail(email)) {
      newErrors.email = "Invalid email format";
      if (!firstErrorField) firstErrorField = "email";
    }

    if (!studentName) {
      newErrors.studentName = "Student Name is required";
      if (!firstErrorField) firstErrorField = "name";
    }
    if (!birthDate) {
      newErrors.birthDate = "Date of Birth is required";
      if (!firstErrorField) firstErrorField = "dateBirth";
    }
    if (!municipality) {
      newErrors.municipality = "Municipality, District is required";
      if (!firstErrorField) firstErrorField = "selectCity";
    }
    if (!studentClass) {
      newErrors.studentClass = "Class is required";
      if (!firstErrorField) firstErrorField = "selectClass";
    }
    if (!address) {
      newErrors.address = "Address is required";
      if (!firstErrorField) firstErrorField = "address";
    }
    if (!gender) {
      newErrors.gender = "Gender is required";
      if (!firstErrorField) firstErrorField = "gender";
    }
    if (!schoolTour) {
      newErrors.schoolTour = "School Tour is required";
      if (!firstErrorField) firstErrorField = "tour";
    }
    if (!fatherName) {
      newErrors.fatherName = "Father's Name is required";
      if (!firstErrorField) firstErrorField = "fathername";
    }
    if (!motherName) {
      newErrors.motherName = "Mother's Name is required";
      if (!firstErrorField) firstErrorField = "mothername";
    }
    if (!phone) {
      newErrors.phone = "Phone Number is required";
      if (!firstErrorField) firstErrorField = "phone";
    } else if (!/^\d{10}$/.test(phone)) {
      newErrors.phone = "Invalid Phone Number";
      if (!firstErrorField) firstErrorField = "phone";
    }
    if (!selectedCertificate) {
      newErrors.selectedCertificate = "Birth Certificate is required.";
      if (!firstErrorField) firstErrorField = "BirthCertificate";
    } else {
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
      ];
      if (!allowedTypes.includes(selectedCertificate.type)) {
        newErrors.selectedCertificate =
          "Only PNG, JPG, JPEG, or PDF files are allowed.";
        if (!firstErrorField) firstErrorField = "BirthCertificate";
      }
    }
    if (studentClass !== "Nursery") {
      if (!previousSchool) {
        newErrors.previousSchool = "Previous School Name is required";
        if (!firstErrorField) firstErrorField = "PreviousSchool";
      }
      if (!previousSchoolAddress) {
        newErrors.previousSchoolAddress = "Previous School Address is required";
        if (!firstErrorField) firstErrorField = "PreviousSchoolAddress";
      }
      if (!selectedAcademic) {
        newErrors.selectedAcademic = "Academic Records is required.";
        if (!firstErrorField) firstErrorField = "academicRecords";
      } else {
        const allowedTypes = [
          "image/png",
          "image/jpeg",
          "image/jpg",
          "application/pdf",
        ];
        if (!allowedTypes.includes(selectedAcademic.type)) {
          newErrors.selectedAcademic =
            "Only PNG, JPG, JPEG, or PDF files are allowed.";
          if (!firstErrorField) firstErrorField = "academicRecords";
        }
      }
    }
    setErrors(newErrors);

    if (firstErrorField) {
      const errorElement = document.getElementById(firstErrorField);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateStep()) {
      return;
    }
    setLoading(true);
    let birthCertificateId = null;
    let academicRecordsId = null;
    try {
      if (selectedCertificate) {
        const formData = new FormData();
        formData.append("files", selectedCertificate);

        const uploadCertificate = await axios.post(
          `${process.env.REACT_APP_strapiUrl}/api/upload`,
          formData,
          {
            headers: {
              Authorization: headers.Authorization,
              "Content-Type": "multipart/form-data",
            },
          },
        );
        birthCertificateId = uploadCertificate.data[0].id;
      }
      if (selectedAcademic) {
        const formData = new FormData();
        formData.append("files", selectedAcademic);

        const uploadAcademic = await axios.post(
          `${process.env.REACT_APP_strapiUrl}/api/upload`,
          formData,
          {
            headers: {
              Authorization: headers.Authorization,
              "Content-Type": "multipart/form-data",
            },
          },
        );
        academicRecordsId = uploadAcademic.data[0].id;
      }
      const data = {
        data: {
          Student_Name: studentName,
          Email: email,
          Phone: phone,
          Gender: gender,
          School_Tour: schoolTour,
          Date_of_Birth: birthDate,
          Municipality: municipality,
          Address: address,
          Father_Name: fatherName,
          Mother_Name: motherName,
          Parent_Name: parentName,
          Class: studentClass,
          Previous_School_Name: previousSchool,
          Previous_School_Address: previousSchoolAddress,
          Birth_Certificate: birthCertificateId,
          Academic_Records: academicRecordsId,
        },
      };
      axios
        .post(`${process.env.REACT_APP_strapiUrl}/api/ega-admissions`, data, {
          headers: headers,
        })
        .then(() => {
          setLoading(false);
          dynamicSuccess("Form submitted successfully!");
          setStudentName("");
          setEmail("");
          setPhone("");
          setGender("");
          setSchoolTour("");
          setBirthDate("");
          setMunicipality("");
          setStudentClass("");
          setPreviousSchool("");
          setAddress("");
          setPreviousSchoolAddress("");
          setFatherName("");
          setMotherName("");
          setParentName("");
          // setRelation("");
          setPreviewCertificate(null);
          setSelectedCertificate("");
          setIsCertificatePdf(false);
          setPreviewAcademic(null);
          setSelectedAcademic("");
          setIsAcademicPdf(false);
          setErrors({});
        })
        .catch(() => {
          setLoading(false);
          failed();
        });
    } catch (e) {
      setLoading(false);
      failed();
    }
  };

  return (
    <section className="py-120" id="admissioninfo">
      <div className="container">
        <div className="border border-neutral-30 rounded-12 bg-main-25 p-24 bg-main-25">
          <div>
            <h3 className="mb-24">Admission Enquiry</h3>
            {/* Personal information Start */}
            <div className="border border-neutral-30 rounded-12 bg-white p-24">
              <h5 className="mb-0">Personal information</h5>
              <span className="d-block border border-main-50 my-24 border-dashed" />
              <div className="row gy-4">
                <div className="col-sm-12">
                  <label
                    htmlFor="name"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Student Name <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className={`common-input bg-main-25 rounded-pill border-transparent focus-border-main-600 ${
                      errors.studentName && "error-border"
                    }`}
                    id="name"
                    placeholder="Enter Your Name..."
                    value={studentName}
                    onChange={(e) => setStudentName(e.target.value)}
                  />
                  {errors.studentName && (
                    <p className="error-message">{errors.studentName}</p>
                  )}
                </div>
                <div className="col-sm-6">
                  <label
                    className="text-neutral-700 text-lg fw-medium mb-12"
                    id="gender"
                  >
                    Gender <span className="text-danger-600">*</span>{" "}
                  </label>
                  <div className="flex-align gap-24">
                    <div className="form-check common-check common-radio mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="studentGender"
                        id="Male"
                        value="Male"
                        checked={gender === "Male"}
                        onChange={(e) => setGender(e.target.value)}
                      />
                      <label
                        className="form-check-label fw-normal flex-grow-1"
                        htmlFor="Male"
                      >
                        Male
                      </label>
                    </div>
                    <div className="form-check common-check common-radio mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="studentGender"
                        id="Female"
                        value="Female"
                        checked={gender === "Female"}
                        onChange={(e) => setGender(e.target.value)}
                      />
                      <label
                        className="form-check-label fw-normal flex-grow-1"
                        htmlFor="Female"
                      >
                        Female
                      </label>
                    </div>
                  </div>
                  {errors.gender && (
                    <p className="error-message">{errors.gender}</p>
                  )}
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="dateBirth"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Date of birth{" "}
                    <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="date"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="dateBirth"
                    value={birthDate}
                    onChange={(e) => setBirthDate(e.target.value)}
                  />
                  {errors.birthDate && (
                    <p className="error-message">{errors.birthDate}</p>
                  )}
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="birthCertificate"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                    id="BirthCertificate"
                  >
                    Birth Certificate{" "}
                    <span className="text-danger-600">*</span>{" "}
                  </label>
                  {previewCertificate ? (
                    <>
                      <div
                        className="user-card__image"
                        style={{ cursor: "default", position: "relative" }}
                      >
                        {isCertificatePdf ? (
                          <iframe
                            src={previewCertificate}
                            title="PDF Preview"
                            style={{
                              width: "80px",
                              height: "80px",
                              border: "1px solid #ccc",
                            }}
                          />
                        ) : (
                          <img src={previewCertificate} alt="Preview" />
                        )}

                        <div
                          className="edit-profil-pic-icon"
                          style={{ top: "0px", left: "65px" }}
                          onClick={handleEditCertificate}
                        >
                          <span className="ph ph-pencil"></span>
                        </div>
                      </div>
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg,.pdf"
                        ref={certificateInputRef}
                        style={{ display: "none" }}
                        onChange={handleCertificateChange}
                      />
                    </>
                  ) : (
                    <>
                      <label
                        htmlFor="certificate-image-upload"
                        className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600 file-label"
                      >
                        Upload (.png, .jpg, .jpeg, .pdf)
                      </label>
                      <input
                        type="file"
                        id="certificate-image-upload"
                        accept=".png,.jpg,.jpeg,.pdf"
                        onChange={handleCertificateChange}
                        style={{ display: "none" }}
                      />
                    </>
                  )}
                  {errors.selectedCertificate && (
                    <p className="error-message">
                      {errors.selectedCertificate}
                    </p>
                  )}
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="selectClass"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Class <span className="text-danger-600">*</span>
                  </label>
                  <Select
                    styles={customStyles}
                    options={schoolClass}
                    value={
                      schoolClass.find((opt) => opt.value === studentClass) ||
                      null
                    }
                    onChange={(selectedOption) =>
                      setStudentClass(selectedOption?.value || "")
                    }
                    placeholder="Select Class"
                    isClearable
                    classNamePrefix="react-select"
                    id="selectClass"
                  />
                  {errors.studentClass && (
                    <p className="error-message">{errors.studentClass}</p>
                  )}
                </div>
                <div className="col-sm-6">
                  <label
                    className="text-neutral-700 text-lg fw-medium mb-12"
                    id="tour"
                  >
                    School Tour <span className="text-danger-600">*</span>{" "}
                  </label>
                  <div className="flex-align gap-24">
                    <div className="form-check common-check common-radio mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tour"
                        id="yes"
                        value="Yes"
                        checked={schoolTour === "Yes"}
                        onChange={(e) => setSchoolTour(e.target.value)}
                      />
                      <label
                        className="form-check-label fw-normal flex-grow-1"
                        htmlFor="yes"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check common-check common-radio mb-0">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tour"
                        id="no"
                        value="No"
                        checked={schoolTour === "No"}
                        onChange={(e) => setSchoolTour(e.target.value)}
                      />
                      <label
                        className="form-check-label fw-normal flex-grow-1"
                        htmlFor="no"
                      >
                        No
                      </label>
                    </div>
                  </div>
                  {errors.schoolTour && (
                    <p className="error-message">{errors.schoolTour}</p>
                  )}
                </div>
                {studentClass !== "Nursery" && studentClass && (
                  <>
                    <div className="col-sm-6">
                      <label
                        htmlFor="PreviousSchool"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Previous School's Name{" "}
                        <span className="text-danger-600">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className={`common-input bg-main-25 rounded-pill border-transparent focus-border-main-600`}
                        id="PreviousSchool"
                        placeholder="Previous School's Name"
                        value={previousSchool}
                        onChange={(e) => setPreviousSchool(e.target.value)}
                      />
                      {errors.previousSchool && (
                        <p className="error-message">{errors.previousSchool}</p>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <label
                        htmlFor="PreviousSchoolAddress"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Previous School's Address{" "}
                        <span className="text-danger-600">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className={`common-input bg-main-25 rounded-pill border-transparent focus-border-main-600`}
                        id="PreviousSchoolAddress"
                        placeholder="Previous School's Address"
                        value={previousSchoolAddress}
                        onChange={(e) =>
                          setPreviousSchoolAddress(e.target.value)
                        }
                      />
                      {errors.previousSchoolAddress && (
                        <p className="error-message">
                          {errors.previousSchoolAddress}
                        </p>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <label
                        htmlFor="academicRecords"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                        id="academicRecords"
                      >
                        Academic Records{" "}
                        <span className="text-danger-600">*</span>{" "}
                      </label>
                      {previewAcademic ? (
                        <>
                          <div
                            className="user-card__image"
                            style={{ cursor: "default", position: "relative" }}
                          >
                            {isAcademicPdf ? (
                              <iframe
                                src={previewAcademic}
                                title="PDF Preview"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  border: "1px solid #ccc",
                                }}
                              />
                            ) : (
                              <img src={previewAcademic} alt="Preview" />
                            )}

                            <div
                              className="edit-profil-pic-icon"
                              style={{ top: "0px", left: "65px" }}
                              onClick={handleEditAcademic}
                            >
                              <span className="ph ph-pencil"></span>
                            </div>
                          </div>
                          <input
                            type="file"
                            accept=".png,.jpg,.jpeg,.pdf"
                            ref={academicInputRef}
                            style={{ display: "none" }}
                            onChange={handleAcademicChange}
                          />
                        </>
                      ) : (
                        <>
                          <label
                            htmlFor="academic-image-upload"
                            className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600 file-label"
                          >
                            Upload (.png, .jpg, .jpeg, .pdf)
                          </label>
                          <input
                            type="file"
                            id="academic-image-upload"
                            accept=".png,.jpg,.jpeg,.pdf"
                            onChange={handleAcademicChange}
                            style={{ display: "none" }}
                          />
                        </>
                      )}
                      {errors.selectedAcademic && (
                        <p className="error-message">
                          {errors.selectedAcademic}
                        </p>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* Personal information End */}
            {/* Parent detail Start */}
            <div className="border border-neutral-30 rounded-12 bg-white p-24 mt-24">
              <h5 className="mb-0"> Parent details </h5>
              <span className="d-block border border-main-50 my-24 border-dashed" />
              <div className="row gy-4">
                <div className="col-sm-12">
                  <label
                    htmlFor="fathername"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Father's Name{" "}
                    <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="fathername"
                    placeholder="Enter Father's Name..."
                    value={fatherName}
                    onChange={(e) => setFatherName(e.target.value)}
                  />
                  {errors.fatherName && (
                    <p className="error-message">{errors.fatherName}</p>
                  )}
                </div>
                <div className="col-sm-12">
                  <label
                    htmlFor="mothername"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Mother's Name{" "}
                    <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="mothername"
                    placeholder="Enter Mother's Name..."
                    value={motherName}
                    onChange={(e) => setMotherName(e.target.value)}
                  />
                  {errors.motherName && (
                    <p className="error-message">{errors.motherName}</p>
                  )}
                </div>
                <div className="col-sm-12">
                  <label
                    htmlFor="parentname"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Parent's Name
                  </label>
                  <input
                    type="text"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="parentname"
                    placeholder="Enter Parent's Name..."
                    value={parentName}
                    onChange={(e) => setParentName(e.target.value)}
                  />
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="email"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Email <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="email"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="email"
                    placeholder="Enter Your Email..."
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && (
                    <p className="error-message">{errors.email}</p>
                  )}
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="Phone"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Phone <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="number"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="Phone"
                    placeholder="Enter Your Number..."
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                  {errors.phone && (
                    <p className="error-message">{errors.phone}</p>
                  )}
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="selectCity"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Municipality, District{" "}
                    <span className="text-danger-600">*</span>{" "}
                  </label>
                  <Select
                    styles={customStyles}
                    options={groupedOptions}
                    value={
                      groupedOptions
                        .flatMap((group) => group.options)
                        .find((opt) => opt.value === municipality) || null
                    }
                    onChange={(selectedOption) =>
                      setMunicipality(selectedOption?.value || "")
                    }
                    placeholder="Select Municipality"
                    isClearable
                    classNamePrefix="react-select"
                    // className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600 form-select py-14"
                    id="selectCity"
                  />
                  {errors.municipality && (
                    <p className="error-message">{errors.municipality}</p>
                  )}
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="selectCountry"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Address <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="address"
                    placeholder="Enter Your Address..."
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                  {errors.address && (
                    <p className="error-message">{errors.address}</p>
                  )}
                </div>
                <div className="col-sm-12">
                  <button
                    type="submit"
                    className="btn btn-main rounded-pill flex-center gap-8 mt-16"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Submit Now
                    <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
                  </button>
                </div>
              </div>
            </div>
            {/* Parent detail End */}
            {/* Education Start */}
            {/* <div className="border border-neutral-30 rounded-12 bg-white p-24 mt-24">
              <h5 className="mb-0">Education</h5>
              <span className="d-block border border-main-50 my-24 border-dashed" />
              <div className="row gy-4">
                <div className="col-sm-6">
                  <label
                    htmlFor="ssName"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    School or college name{" "}
                    <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="ssName"
                    placeholder="Enter Name..."
                  />
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="passYear"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Year of passing
                    <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="passYear"
                    placeholder="Enter year"
                  />
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="boardUniversity"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Board of university{" "}
                    <span className="text-danger-600">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600"
                    id="boardUniversity"
                    placeholder="Enter board..."
                  />
                </div>
                <div className="col-sm-6">
                  <label
                    htmlFor="classGrad"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    Class grad <span className="text-danger-600">*</span>{" "}
                  </label>
                  <select
                    className="common-input bg-main-25 rounded-pill border-transparent focus-border-main-600 form-select py-14"
                    id="classGrad"
                  >
                    <option value="">1st Class</option>
                    <option value="">2nd Class</option>
                    <option value="">3rd Class</option>
                  </select>
                </div>
                <div className="col-sm-12">
                  <label
                    htmlFor="addressEducation"
                    className="text-neutral-700 text-lg fw-medium mb-12"
                  >
                    School or college address
                  </label>
                  <textarea
                    className="common-input bg-main-25 rounded-24 border-transparent focus-border-main-600"
                    id="addressEducation"
                    placeholder="Enter address..."
                    defaultValue={""}
                  />
                </div>
              </div>
            </div> */}
            {/* Education End */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApplyForAdmission;
